import { createContext } from "react"

const CreateBranchStateContext = createContext({})

export {
    CreateBranchStateContext
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Branches/Create/Context/index.jsx